var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/ApplicationConstants.js');
var ActionTypes = Constants.ActionTypes;
var ProductIds = Constants.ProductIds;
var _ = require('lodash');

module.exports = {
    receiveProductList: function (productList) {
        if (!window.NOA.userContext.isAdviser) {
            productList = _.filter(productList, function (p) {
                return p.value != ProductIds.COMMINSURE && p.value != ProductIds.CHALLENGER;
            });
        }
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_PRODUCT_LIST,
            productList: productList
        });
    },
    receiveAnnuityQuoteUrl: function(data){
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_ANNUITY_QUOTE_URL,
            data: data
        });  
    },
    receivedIsProductRegistered: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVED_IS_PRODUCT_REGISTERED,
            data: data
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/ProductsApiCallBackActions.js